import PropTypes from 'prop-types';

import Button from '@mui/material/Button';


export const MenuButton = ({ children, open, handleClick, sx, ...props }) => {

  return (
    <Button
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClick}
      disableRipple={true}
      disableFocusRipple={true}
      disableElevation={true}
      sx={{

        p: 0,

        display: 'flex',
        alignItems: 'center',
        justifyItems: 'center',

        letterSpacing: '0.02em',
        textTransform: 'uppercase',

        '&:hover': {
          backgroundColor: 'transparent',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

MenuButton.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  sx: PropTypes.object,
};
